module.exports = __webpack_public_path__ + "static/media/loc6_img7.428cb4a4.jpg";